import { ProgressBar } from "components/ui/progress-bar";
import { Color } from "utils/theme";
import { Button } from "components/ui/button";
import { Modal } from "components/ui/modal";
import { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Loader2 } from "lucide-react";

export const TransferState = ({ data, onCancel }) => {
  const { t } = useTranslation();

  const [showCancelConfirmation, setShowCancelConfirmation] = useState(false);

  return (
    <section className="w-[400px]">
      <div className="mt-3 flex flex-col space-y-4 justify-center items-center">
        <p className="text-xl font-medium">
          {data?.data?.progress
            ? Number(data?.data?.progress * 100).toFixed(0)
            : 0}
          %
        </p>
        <ProgressBar
          progress={
            data?.data?.progress ? Number(data?.data?.progress) * 100 : 0
          }
        />
        <span className="flex space-x-2 items-center mb-4">
          <Loader2 className="animate-spin w-6 h-6" />
          {data?.data && (
            <p className="text-lg" style={{ color: Color.Primary[400] }}>
              <Trans
                i18nKey={
                  "settings.general_settings.usb_data_transfer.transfer_modal.progress"
                }
                values={{
                  0: data?.data?.trip_files_transferred ?? "-",
                  1: data?.data.total_trip_files ?? "-",
                  2: data?.data?.estimated_time_remaining
                    ? Number(data?.data?.estimated_time_remaining / 60).toFixed(
                        0
                      )
                    : "-",
                }}
              >
                {"{{0}}/{{1}} files (~{{2}} min remaining)"}
              </Trans>
            </p>
          )}
        </span>
      </div>
      <Button
        onClick={() => setShowCancelConfirmation(true)}
        variant="secondary"
        className="mt-4 w-full"
      >
        {t("common.cancel")}
      </Button>
      <Modal
        title={t(
          "settings.general_settings.usb_data_transfer.cancel_modal.title"
        )}
        show={showCancelConfirmation}
      >
        <p>
          {t(
            "settings.general_settings.usb_data_transfer.cancel_modal.description"
          )}
        </p>
        <span className="flex space-x-2 mt-4 w-full">
          <Button
            onClick={() => {
              setShowCancelConfirmation(false);
            }}
            variant="secondary"
          >
            {t(
              "settings.general_settings.usb_data_transfer.cancel_modal.cancel_button"
            )}
          </Button>
          <Button
            onClick={() => {
              setShowCancelConfirmation(false);
              onCancel();
            }}
            variant="destructive"
          >
            {t(
              "settings.general_settings.usb_data_transfer.cancel_modal.confirm_button"
            )}
          </Button>
        </span>
      </Modal>
    </section>
  );
};
